import { createSlice } from '@reduxjs/toolkit'

const integrationState = {
  exists: false,
  path: null,
  client: null,
  patientId: null,
  patientIdSystem: null,
  template: null,
  fullName: null,
}

const initialState = {
  selectedReport: {},
  latestPayload: null,
  fileUploading: false,
  recordingStarted: false,
  recordingDuration: 0,
  reportId: null,
  integration: integrationState,
}

export const reportSlice = createSlice({
  name: 'reportsSlice',
  initialState,
  reducers: {
    setFileUploading: (state, action) => {
      state.fileUploading = action.payload
    },
    setSelectedReport: (state, action) => {
      state.selectedReport = { ...action.payload }
    },
    setLatestPayload: (state, action) => {
      state.latestPayload = action.payload
    },
    setRecordingStarted: (state, action) => {
      state.recordingStarted = action.payload
    },
    setRecordingDuration: (state, action) => {
      state.recordingDuration = action.payload
    },
    setReportId: (state, action) => {
      state.reportId = action.payload
    },
    setIntegration: (state, action) => {
      if (action.payload === 'reset') {
        state.integration = integrationState
        return
      }
      state.integration = { ...state.integration, ...action.payload }
    },
  },
})

export const {
  setSelectedReport,
  setLatestPayload,
  setFileUploading,
  setRecordingStarted,
  setRecordingDuration,
  setReportId,
  setIntegration,
} = reportSlice.actions

export const selectFileUploading = (state) => state.reportsSlice?.fileUploading
export const selectRecordingStarted = (state) => state.reportsSlice?.recordingStarted
export const selectRecordingDuration = (state) => state.reportsSlice?.recordingDuration
export const selectReportId = (state) => state.reportsSlice?.reportId
export const selectIntegration = (state) => state.reportsSlice?.integration
export const selectSelectedReport = (state) => state.reportsSlice?.selectedReport

export default reportSlice.reducer
